import { FormHelperText, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CommonQuillEditor from '../../common/editor';
import { grey } from '@mui/material/colors';

export default function StiloForm({ strainData, setStrainData, errors, isHeading = true, headingText = "title", isBodyText = true }) {
  return (
    <>
      <Grid item xs={12} md={12}>
        <TextField
          label="Meta Title*"
          className="form-input"
          fullWidth
          placeholder="Meta Title"
          value={strainData?.metaTitle || ''}
          onChange={(e) => setStrainData({ ...strainData, metaTitle: e.target.value })}
          error={Boolean(errors?.metaTitle)}
          helperText={errors?.metaTitle}
        />
        <span className='drag_drop'>
          Character Count: {strainData?.metaTitle?.length || 0} <span>(Recommended Characters: 60)</span>
        </span>
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          label="Meta Description*"
          className="form-input"
          fullWidth
          placeholder="Meta Description"
          value={strainData?.metaDescription || ''}
          onChange={(e) => setStrainData({ ...strainData, metaDescription: e.target.value })}
          error={Boolean(errors?.metaDescription)}
          helperText={errors?.metaDescription}
        />
        <span className='drag_drop'>
          Character Count: {strainData?.metaDescription?.length || 0} <span>(Recommended Characters: 160)</span>
        </span>
      </Grid>
      {isHeading && <Grid item xs={12}>
        <TextField
          label='Heading (H1)*'
          fullWidth
          variant='outlined'
          value={strainData?.[headingText] || ''}
          onChange={(e) => setStrainData({ ...strainData, [headingText]: e.target.value })}
          className='form-input'
          error={Boolean(errors?.[headingText])}
          helperText={errors?.[headingText]}
        />
      </Grid>}
      {isBodyText && <Grid item xs={12}>
        <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Body Text*</Typography>
        <CommonQuillEditor
          style={true} height={"400px"}
          allowHeading={false}
          value={strainData?.description || ''}
          onChange={(value) => setStrainData({ ...strainData, description: value })}
        />
        {Boolean(errors?.description) && <FormHelperText error>{errors?.description}</FormHelperText>}
      </Grid>}
    </>
  );
}